'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _startupModal = require('./startupModal.html');

var _startupModal2 = _interopRequireDefault(_startupModal);

var _startup = require('./startup.html');

var _startup2 = _interopRequireDefault(_startup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startupModal = {

    bindings: {
        disable: '='
    },

    template: _startup2.default,

    controller: function controller($scope, $state, $ionicModal, ApiUser, ApiDashboard) {
        var _this = this;

        this.modal = $ionicModal.fromTemplate(_startupModal2.default, {
            scope: $scope
        });
        this.step = 1;
        this.user = {};
        // this.startupVideoUrl = ''; // YouTube video url

        this.$onInit = function () {
            this.dontShowHelp = false;
            this.getUserHelpStatus();
            // Add the youtibe video url here
            this.startupVideoUrl = '';
            ApiDashboard.isStartupDisplayed = true;
        };

        this.openModal = function () {
            _this.modal.show();
        };

        this.closeModal = function () {
            // Uncomment the following line of code
            // this.youtubePlayer.stopVideo();
            _this.modal.hide();
        };

        this.getUserHelpStatus = function () {
            ApiUser.getUser().then(function (res) {
                if (res) {
                    _this.dontShowHelp = !res.showHelp;
                    _this.user = res;
                } else {
                    _this.dontShowHelp = false;
                }
            });
        };

        this.updateUserHelpStatus = function () {
            _this.user.showHelp = !_this.dontShowHelp;
            if (_this.dontShowHelp) {
                ApiUser.deactivateStartupWizard();
            }
            _this.closeModal();
        };
    }
};

exports.default = startupModal;


/** WEBPACK FOOTER **
 ** ./src/app/directives/startupModal/startup.js
 **/